import * as React from 'react';
import { css } from '@emotion/react';

const S = {
  root: css({
    display: 'inline-flex',
    height: '100%',
    verticalAlign: '-0.125em',
    alignItems: 'center',
    justifyContent: 'center',
  }),
};

type _Props = React.ComponentPropsWithoutRef<'svg'> & {
  rootProps?: React.HTMLAttributes<HTMLSpanElement>;
  title?: string;
};

/* eslint-disable import/export */
export const Icon = ({ children, rootProps, title, ...rest }: _Props) => {
  return (
    <span css={S.root} data-testid="icon" role="img" {...rootProps}>
      <svg {...rest}>
        {title && <title data-testid="icon-title">{title}</title>}
        {children}
      </svg>
    </span>
  );
};

Icon.displayName = 'Icon';

// eslint-disable-next-line no-redeclare
export namespace Icon {
  export type Props = _Props;
}
